// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    historyGetApiTwHistoryPairNameResolution (params?: {}): Promise<Dict>;
    publicGetTradeApiAsset (params?: {}): Promise<Dict>;
    publicGetTradeApiCurrencies (params?: {}): Promise<Dict>;
    publicGetTradeApiOrderbooksSymbol (params?: {}): Promise<Dict>;
    publicGetTradeApiOrders (params?: {}): Promise<Dict>;
    publicGetTradeApiPairName (params?: {}): Promise<Dict>;
    publicGetTradeApiPairs (params?: {}): Promise<Dict>;
    publicGetTradeApiPairsPrecisions (params?: {}): Promise<Dict>;
    publicGetTradeApiRates (params?: {}): Promise<Dict>;
    publicGetTradeApiStats (params?: {}): Promise<Dict>;
    publicGetTradeApiTradeId (params?: {}): Promise<Dict>;
    publicGetTradeApiTrades (params?: {}): Promise<Dict>;
    publicGetTradeApiCcxtPairs (params?: {}): Promise<Dict>;
    publicGetTradeApiCmcAssets (params?: {}): Promise<Dict>;
    publicGetTradeApiCmcOrderbookPair (params?: {}): Promise<Dict>;
    publicGetTradeApiCmcSummary (params?: {}): Promise<List>;
    publicGetTradeApiCmcTicker (params?: {}): Promise<Dict>;
    publicGetTradeApiCmcTradesPair (params?: {}): Promise<List>;
    privateGetTradeApiCcxtBalance (params?: {}): Promise<Dict>;
    privateGetTradeApiCcxtOrderId (params?: {}): Promise<Dict>;
    privateGetTradeApiCcxtOrdersOfUser (params?: {}): Promise<Dict>;
    privateGetTradeApiCcxtTradesOfUser (params?: {}): Promise<Dict>;
    privateGetTradeApiTransactionsOfUser (params?: {}): Promise<Dict>;
    privatePostTradeApiCcxtCancelAllOrder (params?: {}): Promise<Dict>;
    privatePostTradeApiCcxtCancelorder (params?: {}): Promise<Dict>;
    privatePostTradeApiCcxtOrdercreate (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
